"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECONCILABLE_RUNGS = exports.strictFold = void 0;
exports.dropTrailingComponent = dropTrailingComponent;
exports.blankComponent = blankComponent;
exports.foldComponents = foldComponents;
exports.composeFolds = composeFolds;
exports.reconcileKeys = reconcileKeys;
exports.leniencyOf = leniencyOf;
const value_comparison_1 = require("../../Comparison/value-comparison");
const match_leniency_1 = require("./match-leniency");
const strictFold = (rowKey) => rowKey;
exports.strictFold = strictFold;
function dropTrailingComponent(componentCount) {
    return (rowKey) => {
        const parts = rowKey.split(value_comparison_1.COMPOSITE_KEY_SEPARATOR);
        if (parts.length !== componentCount) {
            return rowKey;
        }
        return parts.slice(0, -1).join(value_comparison_1.COMPOSITE_KEY_SEPARATOR);
    };
}
function blankComponent(index, componentCount) {
    return (rowKey) => {
        const parts = rowKey.split(value_comparison_1.COMPOSITE_KEY_SEPARATOR);
        if (parts.length !== componentCount || index < 0 || index >= parts.length) {
            return rowKey;
        }
        parts[index] = '';
        return parts.join(value_comparison_1.COMPOSITE_KEY_SEPARATOR);
    };
}
function foldComponents(transform) {
    return (rowKey) => rowKey.split(value_comparison_1.COMPOSITE_KEY_SEPARATOR).map(transform).join(value_comparison_1.COMPOSITE_KEY_SEPARATOR);
}
function composeFolds(...folds) {
    return (rowKey) => folds.reduce((key, fold) => fold(key), rowKey);
}
function reconcileKeys(sourceKeys, targetKeys, rungs) {
    const matches = new Map();
    const remainingSource = [...new Set(sourceKeys)].sort();
    const remainingTarget = new Set(targetKeys);
    for (const rung of rungs) {
        const stillUnmatched = [];
        const targetsByFold = new Map();
        for (const targetKey of [...remainingTarget].sort()) {
            const folded = rung.fold(targetKey);
            const bucket = targetsByFold.get(folded);
            if (bucket === undefined) {
                targetsByFold.set(folded, [targetKey]);
            }
            else {
                bucket.push(targetKey);
            }
        }
        for (const sourceKey of remainingSource) {
            const bucket = targetsByFold.get(rung.fold(sourceKey));
            const targetKey = bucket?.shift();
            if (targetKey === undefined) {
                stillUnmatched.push(sourceKey);
                continue;
            }
            matches.set(sourceKey, { sourceKey, targetKey, leniency: rung.leniency });
            remainingTarget.delete(targetKey);
        }
        remainingSource.length = 0;
        remainingSource.push(...stillUnmatched);
    }
    return {
        matches,
        unmatchedSourceKeys: [...remainingSource],
        unmatchedTargetKeys: [...remainingTarget].sort(),
    };
}
function leniencyOf(reconciliation, sourceKey) {
    return reconciliation.matches.get(sourceKey)?.leniency ?? match_leniency_1.MatchLeniency.Unmatched;
}
exports.RECONCILABLE_RUNGS = match_leniency_1.MATCH_LENIENCY_RUNGS;
//# sourceMappingURL=key-reconciliation.js.map